"use client";

import { useState } from "react";
import { NewsYearMonth } from "@/@types";
import Link from "next/link";
import { ROUTES } from "@/config/routes";
import IconSprite from "../common/IconSprite";

type Props = {
  yearMonths: NewsYearMonth[];
};

export default function NewsYearMonthCard({ yearMonths }: Props) {
  const [openYears, setOpenYears] = useState<{ [key: string]: boolean }>({});
  const [openMonths, setOpenMonths] = useState<{ [key: string]: boolean }>({});

  const toggleYear = (year: string) => {
    setOpenYears((prev) => ({
      ...prev,
      [year]: !prev[year],
    }));
  };

  const toggleMonth = (year: string, month: string) => {
    const key = `${year}-${month}`;
    setOpenMonths((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const capitalizeFirstLetter = (str: string): string =>
    str.charAt(0).toUpperCase() + str.slice(1);

  return (
    <div>
      {yearMonths.map((date) => {
        const yearOpen = openYears[date.year];
        return (
          <div key={date.year} className="mb-2">
            <button
              onClick={() => toggleYear(date.year)}
              className="w-full flex items-center justify-between bg-white border-grey border-b-2 p-2 text-dark01 hover:bg-light01 focus:outline-none"
            >
              <span className="font-semibold">{date.year}</span>
              <IconSprite id="ic_arrow_down" className={`${yearOpen ? 'rotate-180' : ''} w-3 h-3`} />
            </button>
            {yearOpen && (
              <div className="ml-2">
                {date.months.map((month) => {
                  const key = `${date.year}-${month.month}`;
                  const monthOpen = openMonths[key];

                  return (
                    <div key={key}>
                      <button
                        onClick={() => toggleMonth(date.year, month.month)}
                        className="w-full flex items-center justify-between bg-white border-grey border-b-2 p-2 text-dark01 hover:bg-light01 focus:outline-none"
                      >
                        <span>{capitalizeFirstLetter(month.month)}</span>
                        <IconSprite id="ic_arrow_down" className={`${monthOpen ? 'rotate-180' : ''} w-3 h-3`} />
                      </button>

                      {monthOpen && (
                        <div className="ml-2">
                          {month.news.map((news) => (
                            <Link
                              key={news.id}
                              href={ROUTES.news.details(news.categorySlug, news.slug)}
                              className="block py-2 text-sm text-dark01 bg-white hover:bg-light01 px-2 border-b border-light01"
                            >
                              {`${news.title}`}
                            </Link>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
